import { forwardRef, type Ref } from "react";
import type { IButton } from "./types";
import { ButtonContainer, StyledButton } from "./style";

const Button = forwardRef(
  (
    {
      children,
      label,
      color,
      type,
      buttonClassName,
      isLoading,
      style,
      onClick,
      disabled,
    }: IButton,
    ref: Ref<HTMLButtonElement>,
  ) => {
    return (
      <ButtonContainer className={buttonClassName}>
        {label !== undefined && <label>{label}</label>}
        <StyledButton
          $color={color || "primary"}
          $isLoading={isLoading}
          ref={ref}
          type={type ? type : "button"}
          style={style}
          onClick={onClick}
          disabled={disabled}
        >
          {!isLoading ? children : ""}
        </StyledButton>
      </ButtonContainer>
    );
  },
);

export default Button;
